// 本地環境配置文件
// 用於控制調試信息的顯示

// 調試信息控制
const DEBUG_CONFIG = {
  // 主要調試開關
  SHOW_DEBUG: false, // 設置為 true 來顯示調試信息

  // 詳細調試功能開關
  SHOW_TOKEN_DEBUG: false, // Token 相關調試
  SHOW_USER_DEBUG: false, // 用戶數據調試
  SHOW_API_DEBUG: false, // API 調試日誌

  // 應用配置
  APP_NAME: "兒童成長發育門診系統",
  APP_VERSION: "1.0.0",

  // 環境識別
  NODE_ENV: process.env.NODE_ENV || "development",

  // 檢查是否啟用調試
  isDebugEnabled() {
    return this.SHOW_DEBUG;
  },

  // 獲取調試配置
  getDebugConfig() {
    return {
      showDebug: this.isDebugEnabled(),
      showTokens: this.SHOW_TOKEN_DEBUG,
      showUserData: this.SHOW_USER_DEBUG,
      showApiLogs: this.SHOW_API_DEBUG,
    };
  },
};

export default DEBUG_CONFIG;
